<mat-toolbar color="primary" class="item-panel-toolbar">
    <span>RX Serie</span>
    <span> ( {{ serie.name }} )</span>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button (click)="openDicomViewer()">
        <fa-icon [icon]="['fas','tv']" size="lg"></fa-icon>
    </button>
</mat-toolbar>
<mat-dialog-content>
    <div style="min-height:80vh;max-height:80vh;min-width:80vw;max-width:80vw;">
        <div fxLayout="row" style="min-height:80vh;max-height:80vh;min-width:80vw;max-width:80vw;">
            <div fxFlex="250px" style="min-height:80vh;max-height:80vh;overflow-y:scroll;">
                <app-rx-image-table [serie]="serie" (selected)="showImage($event)"></app-rx-image-table>
            </div>
            <div fxFlex style="min-height:80vh;max-height:80vh;">
                <app-rx-image-viewer [image]="selectedImage"></app-rx-image-viewer>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-stroked-button (click)="close()">Fermer</button>
</mat-dialog-actions>